export const allLangs = [
  {
    label: "English",
    value: "en",
    direction: "ltr",
    icon: "flagpack:gb-nir",
    numberFormat: {
      code: "en-US",
      currency: "USD",
    },
  },
  {
    label: "Turkish",
    value: "tr",
    direction: "ltr",
    icon: "flagpack:gb-nir",
    numberFormat: {
      code: "tr",
      currency: "lir",
    },
  },
];

export const defaultLang = allLangs[0]; // English

// GET MORE COUNTRY FLAGS
// https://icon-sets.iconify.design/flagpack/
// https://www.dropbox.com/sh/nec1vwswr9lqbh9/AAB9ufC8iccxvtWi3rzZvndLa?dl=0
